<md-icon icon="untitled-ui/general/copy-04" (click)="copyText($event)"></md-icon>

@if (isTextVisible()) {
	<div
		[style.position]="'absolute'"
		[style.top.px]="textPosition.y"
		[style.left.px]="textPosition.x"
		style="background: white; padding: 5px; border: 1px solid black; border-radius: 4px; font-size: 10px"
	>
		{{ confirmationText() }}
	</div>
}
